/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { NameType } from '../../models/name-type';
import { OrganizationSiteMetaDataResponse } from '../../models/organization-site-meta-data-response';

export interface GetOrganizationSiteMetaData$Params {
  organizationKey: KeyType;
  organizationSiteKey: KeyType;
  metaDataKey: NameType;
}

export function getOrganizationSiteMetaData(http: HttpClient, rootUrl: string, params: GetOrganizationSiteMetaData$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationSiteMetaDataResponse>> {
  const rb = new RequestBuilder(rootUrl, getOrganizationSiteMetaData.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('metaDataKey', params.metaDataKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationSiteMetaDataResponse>;
    })
  );
}

getOrganizationSiteMetaData.PATH = '/organizations/{organizationKey}/organization-sites/{organizationSiteKey}/metadata/{metaDataKey}';
